import React, { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  useAddActivity,
  useDeleteAuditor,
  useGetAllDocumentsList,
  useGetAuditorsListForFilters,
  UseGetRfiListForFilters,
  useGetVQAActivity,
  useGetVQADetails,
  useGetVQARequestDetailsAdmin,
  useUpdateBackendAssessmentDetails,
  useVQAAssessmentOverviewAdmin,
  useVQAProviderContactAdmin,
  useVQASponsorContactAdmin,
} from "../../custom-hooks/queries";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { calculateDaysAgo, dateFormat } from "../../utils/helperMethods";
import { Switch } from "@headlessui/react";
import UploadReportModal from "../../components/uploadReportModal";
import {
  CalendarDaysIcon,
  CheckBadgeIcon,
  ChevronRightIcon,
  DocumentIcon,
  EnvelopeIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import CustomTooltip from "../../components/Filters/CustomTooltip";
import { useDispatch } from "react-redux";
import { setDrawer } from "../../redux-store/features/layoutSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomButton from "../../components/CustomButton";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { sponsorContactSchema } from "../../Schema/updateSponsorContactSchema";
import { providerContactSchema } from "../../Schema/updateProviderContactSchema";
import Datepicker from "react-tailwindcss-datepicker";
import { updateAssessmentOverviewSchema } from "../../Schema/updateAssessmentOverview";
import FormModal from "../../components/FormModal";
import Notification from "../../components/Notification";
import Capabilities from "../../components/Capabilities";
import StatusProgressBar from "../../components/ProgressBar";
import CheckedDropdown from "../../components/CheckedDropdown";
import { assessmentStatusDropdown } from "../../utils/constants";
import {
  Autocomplete,
  LoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import ComboBox from "../../components/ComboBox";
import { adminDetailSchema } from "../../Schema/adminDetailSchema";
import DatePickerController from "../../components/datePickerController";
import Skeleton from "react-loading-skeleton";
import AdminDetailsLoader from "../../components/Skeletons/adminDetailsLoader";
import ReportAndActivitySkeletonLoader from "../../components/Skeletons/ReportAndActivitySkeletonLoader";
import NotificationModal from "../../components/NotificationModal";
import { getVQALocationFromProvider } from "../../utils/addressUtils";

export const BackendRequestDetailPage = () => {
  const { id } = useParams();
  const { data: activity, refetch: activityRefetch } = useGetVQAActivity(id);
  const [enabled, setEnabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const { data: rfis } = UseGetRfiListForFilters();
  const {
    data: vqaDetails,
    isLoading,
    refetch: vqaDetailsRefetch,
  } = useGetVQARequestDetailsAdmin(id);

  const { data: auditors } = useGetAuditorsListForFilters();
  const [selectedStatus, setSelectedStatus] = useState(""); // Default selection index
  const optionsForMultiSelect = rfis?.map((item) => ({
    value: item?.rfi_id,
    label: item?.rfi_name,
  }));
  const formattedCapabilities =
    vqaDetails?.capabilities?.map((capability) => ({
      value: capability.rfi_id,
      label: capability.rfi_name,
    })) || [];

  const serviceCategories = vqaDetails?.capabilities.map((item) => ({
    value: item.rfi_id,
    label: item.rfi_name,
  }));

  const optionsForMultiSelectAuditor = auditors?.map((item) => ({
    id: item?.vqa_auditor_id,
    name: item?.vqa_auditor_name,
  }));

  const { data: allDocuments, refetch } = useGetAllDocumentsList(
    1,
    [],
    [],
    [],
    [],
    [],
    id
  );

  const { mutate } = useAddActivity();
  const { mutate: deleteAuditor } = useDeleteAuditor();
  const { mutate: updateBackendDetails } = useUpdateBackendAssessmentDetails();

  const dispatch = useDispatch();
  const [comment, setComment] = useState("");

  const handleModalOpen = () => {
    dispatch(setDrawer(true));
    setOpen(true);
  };

  const addComment = (e) => {
    mutate(
      { vqa_id: id, comment },
      {
        onSuccess: () => {
          setComment("");
          setStatus("success");
          setMessage("Your comment has been successfully added.");
          setShow(true);
          activityRefetch();
        },
      }
    );
  };
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(adminDetailSchema),
    defaultValues: {
      multiSponsor: true,
      onsiteRemote: {
        onsite: false,
        remote: false,
      },
    },
  });

  const onSubmit = (data) => {
    const transformedCapabilities = data.serviceCategories?.map((service) => ({
      rfi_id: service.value,
      rfi_name: service.label,
    }));
    const updatedSponsors =
      data.sponsors?.map((sponsor) => ({
        sponsor_id: sponsor.sponsor_id,
        sponsor_name: sponsor.sponsorName || sponsor.sponsor_name, // Updated name or existing name
        sponsor_contact_name:
          sponsor.sponsorContactName || sponsor.sponsor_contact_name, // Updated contact name or existing
        sponsor_contact_email:
          sponsor.sponsorEmail || sponsor.sponsor_contact_email, // Updated email or existing email
        sponsor_contact_phone:
          sponsor.sponsorPhone || sponsor.sponsor_contact_phone, // Updated phone or existing phone
        is_primary_sponsor:
          sponsor.isPrimarySponsor || sponsor.is_primary_sponsor, // Updated or existing flag
      })) || [];

    const vqaData = {
      capabilities: transformedCapabilities,
      finalReportDate: data?.FinalReportDate?.startDate,
      capaDelieveredToSponsorDate: data?.capaDelieveredToSponsorDate?.startDate,
      draftDelieveredToVendorDate: data?.draftDelieveredToVendorDate?.startDate,
      firstAssessmentDate: data?.firstAssessmentDate?.startDate,
      firstDraftDelieveredSponsorDate:
        data?.firstDraftDelieveredSponsorDate?.startDate,
      firstDraftUplaodedDate: data?.firstDraftUplaodedDate?.startDate,
      planningMeetingDate: data?.planningMeetingDate?.startDate,
      requestDate: data?.requestDate?.startDate,
      additionalDetails: data?.additionalDetails,
      capaNeeded: data?.capaNeeded,
      multiSponsor: data?.multiSponsor,
      providerEmail: data?.providerEmail,
      providerName: data?.providerName,
      providerId: vqaDetails?.provider?.provider_id,
      providerPhone: JSON.stringify(data?.providerPhone),
      vqaStatus: selectedStatus,
      auditorId: data?.auditors?.id,
      auditorName: data?.auditors?.name,
      sponsors: updatedSponsors, // Include updated sponsors
    };
    updateBackendDetails(
      { vqaId: id, vqaData },
      {
        onSuccess: () => {
          setMessage("Assessment of Backend User updated");
          reset();
          vqaDetailsRefetch();
          setNotificationOpen(true);
        },
      }
    );
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);

  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("success");
  const [autocomplete, setAutocomplete] = useState(null);
  const libraries = ["places"]; // We need 'places' for Google Places Autocomplete
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
  const [address, setAddress] = useState();
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCmiTZu8oGRJ-yZVYPi7CLnzYWsMi-wkz8",
    libraries,
  });

  const handleChange = (e) => {
    setComment(e.target.value);
  };
  const handleOnLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const handleDeleteAuditor = (id) => {
    deleteAuditor(id, {
      onSuccess: () => {
        setMessage("Deleted successfully");
        setStatus("success");
        setShow(true);
      },
    });
  };
  const animatedComponents = makeAnimated();
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#AB54DB" : "white", // Purple background on hover
      color: state.isFocused ? "white" : "black", // White text on hover for better contrast
    }),
  };

  useEffect(() => {
    if (vqaDetails?.capabilities) {
      const formattedCapabilities = vqaDetails.capabilities.map(
        (capability) => ({
          value: capability.id,
          label: capability.name,
        })
      );
      setValue("serviceCategories", formattedCapabilities);
    }
  }, [vqaDetails, setValue]);

  useEffect(() => {
    if (updateActive && vqaDetails?.capabilities) {
      setValue(
        "serviceCategories",
        vqaDetails.capabilities.map((capability) => ({
          value: capability.rfi_id,
          label: capability.rfi_name,
        }))
      );
    }
  }, [updateActive, vqaDetails, setValue]);

  const [selectedAuditor, setSelectedAuditor] = useState(""); // State for selected value
  return (
    <div className="container ">
      {isLoading ? (
        <Skeleton
          className="w-full h-32 p-7 border-y border-gray-300 bg-slate-50 mb-10"
          enableAnimation={true}
        />
      ) : (
        <div className="p-7 border-y border-gray-300 bg-slate-50 mb-10 ">
          <div className="flex items-center text-sm">
            <h1
              className="text-gray-500 cursor-pointer font-semibold"
              onClick={() => navigate("/Backend/Assessment/History")}
            >
              Assessments
            </h1>
            <ChevronRightIcon className="w-5 h-5 text-gray-400" />
            <p className="ml-5 font-semibold">
              {vqaDetails?.vqa_reference_number}
            </p>
            <p className="font-semibold">
              {" "}
              {vqaDetails?.vqa_request_reference_number}
            </p>
          </div>
          <div className="mt-5 space-y-2 flex  flex-col justify-start items-start md:justify-between md:items-center md:flex-row">
            <div className="flex items-center">
              <span className="bg-white border border-gray-300 rounded-md px-7 py-5 mr-5">
                <CheckBadgeIcon className="h-9 w-9 text-red-500" />
              </span>

              <span>
                <p className="text-lg font-semibold">
                  {vqaDetails?.provider?.provider_name}
                </p>
                <p className="text-sm text-gray-500">
                  Request Date{" "}
                  <span className="text-black">
                    {dateFormat(vqaDetails?.vqa_request_created_on)}
                  </span>
                </p>
              </span>
            </div>
            {/* <div className="flex items-center justify-between md:justify-center ">
              {updateActive ? (
                <>
                  <CustomButton
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-[5rem]"
                    textColor="text-green-500"
                    text={"Save"}
                    onClick={(e) => {
                      e.preventDefault();
                      // setUpdateActive(false);
                      handleSubmit((data) => {
                        onSubmit(data);
                      })();
                    }}
                  />

                  <CustomButton
                    size="text-base"
                    weight="font-normal"
                    height="h-9"
                    width="w-[5rem]"
                    textColor="text-red-500"
                    text={"Cancel"}
                    onClick={() => {
                      setUpdateActive(false);
                      reset();
                    }}
                  />
                </>
              ) : (
                <CustomButton
                  size="text-base"
                  weight="font-normal"
                  height="h-9"
                  width="w-36"
                  textColor="text-black"
                  text={"Update"}
                  onClick={() => {
                    
                  }}
                />
              )}
              <CheckedDropdown
                publishingOptions={assessmentStatusDropdown}
                setSelectedStatus={setSelectedStatus}
                selectedStatus={selectedStatus}
                setUpdateActive={setUpdateActive}
              />
            </div> */}
          </div>
        </div>
      )}
      <div className="mb-28 px-5 flex justify-center flex-col items-center md:justify-between md:flex-row md:items-start ">
        {isLoading ? (
          <div className="w-full md:w-[90%] border-r border-gray-300 px-3 mr-8 ">
            <AdminDetailsLoader />
          </div>
        ) : (
          <form
            className="w-full lg:w-[90%] md:w-[70%] border-r border-gray-300 px-3 mr-8 "
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className=" border-b border-gray-300">
              <h1 className="text-sm font-medium text-gray-900">
                Assessment Details
              </h1>
            </div>
            <div className="my-5">
              <StatusProgressBar
                status={
                  selectedStatus.length === 0
                    ? vqaDetails?.vqa_request_status
                    : selectedStatus
                }
              />
            </div>
            <div className="">
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  Assessment Type
                </h2>
                <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="onsite"
                      {...register("onsiteRemote.onsite")} // Correctly register for "onsite"
                      onChange={() => {
                        setValue("onsiteRemote", {
                          onsite: true,
                          remote: false,
                        });
                      }}
                      checked={watch("onsiteRemote.onsite")} // Dynamically track state
                    />
                    <label htmlFor="onsite">Onsite</label>
                  </span>
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="remote"
                      {...register("onsiteRemote.remote")} // Correctly register for "remote"
                      onChange={() => {
                        setValue("onsiteRemote", {
                          onsite: false,
                          remote: true,
                        });
                      }}
                      checked={watch("onsiteRemote.remote")} // Dynamically track state
                    />
                    <label htmlFor="remote">Remote</label>
                  </span>
                </div>
              </div>

              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  Multi Sponsor
                </h2>
                <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-[6.3rem]">
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="multi-sponsor-yes"
                      value={true} // The value of "Yes" option is true
                      {...register("multiSponsor", {
                        onChange: () => {},
                      })}
                    />
                    <label htmlFor="multi-sponsor-yes">Yes</label>
                  </span>
                  <span className="space-x-3">
                    <input
                      type="radio"
                      id="multi-sponsor-no"
                      value={false} // The value of "No" option is false
                      {...register("multiSponsor", {
                        onChange: () => {},
                      })}
                    />
                    <label htmlFor="multi-sponsor-no">No</label>
                  </span>
                </div>
              </div>

              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">
                  Additional Participating Sponsors{" "}
                </h2>
                <p className="mt-1 text-sm/6 text-indigo-600 sm:col-span-2 sm:mt-0 font-semibold cursor-pointer">
                  -
                </p>
              </div>
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">Location </h2>
                {updateActive ? (
                  <Controller
                    name="location"
                    control={control}
                    defaultValue={vqaDetails?.provider?.provider_address1 || ""} // Ensure the default value is set correctly
                    render={({ field }) => (
                      <Autocomplete
                        onLoad={handleOnLoad}
                        onPlaceChanged={() => {
                          if (autocomplete) {
                            const place = autocomplete.getPlace();
                            const address = place.formatted_address || "";

                            // Update the form field with the new address
                            field.onChange(address);
                            setAddress(address);

                            // If geometry is available, set coordinates
                            if (place.geometry) {
                              const { lat, lng } = place.geometry.location;
                              setCoordinates({
                                lat: lat(),
                                lng: lng(),
                              });
                            }
                          }
                        }}
                      >
                        <input
                          {...field}
                          type="text"
                          placeholder="Enter an address"
                          className="border-gray-300 rounded-md text-sm w-[310px] md:w-[300px] custom-breakpoint-5:w-[310px] xl:w-[644px]"
                          value={field.value || ""} // Ensure the value is set properly
                        />
                      </Autocomplete>
                    )}
                  />
                ) : (
                  <p className="mt-1 text-sm/6 sm:col-span-2 sm:mt-0 ">
                    {getVQALocationFromProvider(vqaDetails?.provider, { short: false, abbvState: true }) || ""}
                  </p>
                )}
              </div>
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">Auditor</h2>
                <p className="mt-1 text-sm/6 text-indigo-600 sm:col-span-2 sm:mt-0 cursor-pointer hover:text-indigo-600 hover:underline">
                  {updateActive ? (
                    <Controller
                      name="auditors" // Matches the Yup schema
                      control={control}
                      defaultValue={{ onsite: true, remote: false }}
                      render={({ field }) => (
                        <ComboBox
                          data={optionsForMultiSelectAuditor}
                          placeHolder="Select Auditors..."
                          setSelected={(value) => {
                            // Update the value of onsiteRemote
                            setValue("auditors", value);
                          }}
                          selected={watch("auditors")}
                          width={"w-full"}
                          inputWidth={"w-full"}
                        />
                      )}
                    />
                  ) : (
                    "-"
                  )}
                </p>
                <span className="text-red-600">
                  {errors?.auditors?.message}
                </span>
              </div>
              <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                <h2 className="text-sm font-medium text-gray-900">Scope</h2>
                <span className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">
                  {updateActive ? (
                    vqaDetails && (
                      <Controller
                        name="serviceCategories"
                        control={control}
                        defaultValue={
                          vqaDetails?.capabilities?.map((capability) => ({
                            value: capability.rfi_id,
                            label: capability.rfi_name,
                          })) || []
                        }
                        render={({ field }) => (
                          <Select
                            {...field}
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            isMulti
                            options={optionsForMultiSelect?.map((option) => ({
                              ...option,
                              isDisabled:
                                option.value ===
                                "106c4bdc-e1c2-4fca-9ab6-745b995c65ee", // Disable the Core RFI
                            }))}
                            value={[
                              {
                                value: "106c4bdc-e1c2-4fca-9ab6-745b995c65ee",
                                label: "Core VQQ",
                              }, // Ensure Core VQQ is always selected
                              ...(field.value?.filter(
                                (item) =>
                                  item.value !==
                                  "106c4bdc-e1c2-4fca-9ab6-745b995c65ee"
                              ) || []),
                            ]}
                            isClearable={field.value?.length > 1}
                            className="w-full"
                            styles={{
                              ...customStyles,
                              multiValue: (base) => ({
                                ...base,
                                borderRadius: "0.375rem",
                                fontSize: "0.75rem",
                                fontWeight: "500",
                                height: "auto",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                border: "2px solid #d1d5db",
                                color: "black",
                                backgroundColor: "white",
                                paddingLeft: "10px",
                              }),
                            }}
                          />
                        )}
                      />
                    )
                  ) : (
                    <Capabilities
                      services={vqaDetails?.capabilities}
                      icon={true}
                      showLimited={false}
                    />
                  )}
                </span>
              </div>
            </div>
            <div className="">
              <h1 className="text-lg mt-3 font-medium text-gray-900">
                Vendor Contacts
              </h1>
            </div>
            <div className="">
              <div className="px-0 py-4 border-b border-gray-300 sm:grid sm:grid-cols-2 sm:gap-4">
                <div>
                  <h2 className="text-sm font-medium text-gray-900">Vendor</h2>
                  <p className="mt-1 text-sm/6 text-gray-700">
                    <div className="space-x-3">
                      {updateActive ? (
                        <div>
                          <div className="mt-2">
                            <input
                              id="providerName"
                              name="providerName"
                              type="text"
                              defaultValue={
                                vqaDetails?.provider?.provider_contact_name
                              }
                              {...register("providerName")}
                              placeholder="Vendor Name"
                              className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                            />
                          </div>
                        </div>
                      ) : vqaDetails?.provider?.provider_contact_display ||
                        vqaDetails?.provider?.provider_contact_name ? (
                        vqaDetails?.provider?.provider_contact_display ||
                        vqaDetails?.provider?.provider_contact_name
                      ) : (
                        "-"
                      )}
                    </div>
                    <div className="space-x-3">
                      {" "}
                      {updateActive ? (
                        <div>
                          <div className="mt-2 grid grid-cols-1">
                            <input
                              id="email"
                              name="email"
                              type="email"
                              defaultValue={
                                vqaDetails?.provider?.provider_contact_email
                              }
                              {...register("providerEmail")}
                              placeholder="you@example.com"
                              className="col-start-1 row-start-1 border border-gray-300 block w-full rounded-md bg-white py-1.5 pl-10 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pl-9 sm:text-sm/6"
                            />
                            <EnvelopeIcon
                              aria-hidden="true"
                              className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
                            />
                          </div>
                        </div>
                      ) : vqaDetails?.provider?.provider_contact_email !==
                        null ? (
                        vqaDetails?.provider?.provider_contact_email
                      ) : (
                        "-"
                      )}
                    </div>
                    <div className="space-x-3">
                      {" "}
                      {updateActive ? (
                        <div>
                          <div className="mt-2">
                            <div className="flex rounded-md bg-white outline outline-1 -outline-offset-1 outline-gray-300 has-[input:focus-within]:outline has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-indigo-600">
                              <div className="grid shrink-0 grid-cols-1 focus-within:relative"></div>
                              <input
                                id="phone-number"
                                name="phone-number"
                                type="number"
                                defaultValue={
                                  vqaDetails?.provider?.provider_contact_phone
                                }
                                {...register("providerPhone")}
                                placeholder="123-456-7890"
                                className="block min-w-0 grow py-1.5 pl-1 border border-gray-300 pr-3 text-base text-gray-900 placeholder:text-gray-400 sm:text-sm/6"
                              />
                            </div>
                          </div>
                        </div>
                      ) : vqaDetails?.provider?.provider_contact_phone !==
                        null ? (
                        vqaDetails?.provider?.provider_contact_phone
                      ) : (
                        "-"
                      )}
                    </div>
                  </p>
                </div>
              </div>
            </div>
            <div className="">
              <div className="">
                <h1 className="text-lg mt-3 font-medium text-gray-900">
                  Assessment Dates
                </h1>
              </div>
              <div className="px-0 py-4">
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">Request</h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      <label htmlFor="">
                        <p className="mt-1 text-sm/6 sm:col-span-2 sm:mt-0 ">
                          {vqaDetails?.desired_initial_draft_date !== null
                            ? dateFormat(vqaDetails?.desired_initial_draft_date)
                            : "-"}
                        </p>
                      </label>
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="">
              <div className="">
                <h1 className="text-lg mt-3 font-medium text-gray-900">
                  CAPA Details
                </h1>
              </div>
              <div className="px-0 py-4">
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    CAPA Needed{" "}
                  </h2>
                  <div className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-[6.3rem]">
                    <span className="space-x-3">
                      <input
                        type="radio"
                        id="capa-needed-yes"
                        value={true} // The value of "Yes" option is true
                        {...register("capaNeeded", {
                          onChange: () => setUpdateActive(true),
                        })}
                      />
                      <label htmlFor="capa-needed-yes">Yes</label>
                    </span>
                    <span className="space-x-3">
                      <input
                        type="radio"
                        id="capa-needed-no"
                        value={false} // The value of "No" option is false
                        {...register("capaNeeded", {
                          onChange: () => setUpdateActive(true),
                        })}
                      />
                      <label htmlFor="capa-needed-no">No</label>
                    </span>
                  </div>
                </div>
              </div>

              <div className="px-0 py-4">
                <div className="px-0 py-4 sm:grid sm:grid-cols-3 sm:gap-4 border-b border-gray-300">
                  <h2 className="text-sm font-medium text-gray-900">
                    CAPA Delievered to Sponsor Date
                  </h2>
                  <p className="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0 space-x-20">
                    <span>
                      {updateActive ? (
                        <DatePickerController
                          control={control}
                          fieldName={"capaDelieveredToSponsorDate"}
                        />
                      ) : (
                        "-"
                      )}{" "}
                    </span>
                  </p>
                </div>
              </div>
              <div className="px-0 py-4">
                <div>
                  <label
                    htmlFor="comment"
                    className="block text-sm/6 font-medium text-gray-900"
                  >
                    Additonal Info
                  </label>
                  <div className="mt-2">
                    <textarea
                      id="comment"
                      name="comment"
                      rows={4}
                      {...register("additionalDetails")}
                      className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      defaultValue={""}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
        {isLoading ? (
          <ReportAndActivitySkeletonLoader />
        ) : (
          <div className="w-full md:w-[30%] mt-10 md:mt-0">
            <div className="border border-gray-300 rounded-md p-5 bg-gray-100">
              <div className="border-b border-gray-300">
                <h1 className="font-semibold text-md">Reports</h1>
              </div>
              <div className="py-5 border-b border-gray-300">
                {allDocuments?.items?.map((item) => (
                  <div className="flex items-center justify-between border-b border-gray-300 py-5">
                    <DocumentIcon className="w-5 h-5 text-gray-500" />
                    <p className="text-sm text-gray-500">
                      <CustomTooltip cutOffAfter={15} sliceLength={15}>
                        {item.document_name}
                      </CustomTooltip>
                    </p>
                    <span className="text-sm font-semibold">Edit</span>
                  </div>
                ))}
              </div>
              <div className="text-center py-5">
                <button
                  onClick={() => {
                    handleModalOpen();
                  }}
                >
                  Upload New Report <span className="text-xl"> +</span>
                </button>
                {/* <input type="file" name="" id="" /> */}
              </div>
            </div>

            <div className="mt-10 md:mt-6">
              <h2 className="text-sm font-semibold text-gray-900">
                Assessment Activity
              </h2>
              <ul className="mt-6 space-y-6">
                {activity?.items?.map((item, index) => (
                  <li key={index} className="relative flex gap-x-4">
                    {/* Line connecting items */}
                    <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                      <div className="w-px bg-gray-200"></div>
                    </div>

                    {/* Circle or Profile Picture */}
                    <div className="relative flex h-6 w-6 items-center justify-center bg-white">
                      {item?.activity_comments ? (
                        <div className="h-6 w-6 rounded-full bg-gray-200 flex items-center justify-center ring-2 ring-gray-300">
                          <span className="text-xs font-medium text-gray-700">
                            {item?.activity_done_by?.charAt(0).toUpperCase() ||
                              "A"}
                          </span>
                        </div>
                      ) : (
                        <div className="h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300"></div>
                      )}
                    </div>

                    {/* Activity Description and Comment */}
                    <div className="flex-auto">
                      <p className="py-0.5 text-xs text-gray-500">
                        <span className="font-medium text-gray-900">
                          {!item?.activity_comments && item?.activity_done_by}
                        </span>{" "}
                        {item?.activity_description}
                      </p>
                      {item?.activity_comments && (
                        <div className="mt-2 rounded-md border border-gray-300 p-3 text-sm text-gray-800 shadow-sm w-[110%]">
                          <div className="flex justify-between ">
                            <span className="font-medium text-gray-900 text-xs">
                              {item?.activity_done_by}{" "}
                              <span className="py-0.5 text-xs leading-5 text-gray-500 font-normal">
                                commented
                              </span>
                            </span>
                            <time
                              dateTime={item?.activity_done_on}
                              className="flex-none py-0.5 text-xs text-gray-500 "
                            >
                              {calculateDaysAgo(item?.activity_done_on)}
                            </time>
                          </div>
                          <div className="text-gray-500 text-sm mt-2">
                            {item?.activity_comments}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Activity Time */}
                    <time
                      dateTime={item?.activity_done_on}
                      className="flex-none py-0.5 text-xs text-gray-500"
                    >
                      {!item?.activity_comments &&
                        calculateDaysAgo(item?.activity_done_on)}
                    </time>
                  </li>
                ))}
              </ul>

              <div className="border border-gray-300 rounded-md mt-10 p-4">
                <div className="flex flex-col gap-4">
                  <input
                    placeholder="Add your comment..."
                    name="comment"
                    id="comment"
                    value={comment}
                    className="border-hidden w-full focus:outline-none focus:border-transparent focus:ring-0 rounded-md text-sm"
                    onChange={(e) => handleChange(e)}
                  />

                  <div className="self-end">
                    <CustomButton
                      color="bg-white"
                      size="text-sm" // Adjusted size to better match button
                      weight="font-medium"
                      height="h-9"
                      width="w-24"
                      textColor="text-black"
                      text="Comment"
                      border="border border-gray-300"
                      onClick={() => addComment()}
                      disabled={!comment.trim()} // Disable button if input is empty
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <UploadReportModal
          open={open}
          setOpen={setOpen}
          vqaId={vqaDetails?.vqa_id}
          providerId={vqaDetails?.provider_id}
          vqaDetails={vqaDetails}
          refetch={refetch}
        />{" "}
        <FormModal open={modalOpen} setOpen={setModalOpen} />
        <NotificationModal
          open={notificationOpen}
          setOpen={setNotificationOpen}
          desc={message}
          title={"Success"}
        />
      </div>
    </div>
  );
};
